import { IStatusCodeMessage } from "..";

export enum INotificationEvents {
  APPOINTMENT_BOOKED = "APPOINTMENT_BOOKED",
  APPOINTMENT_BOOKED_BY_OTHERS = "APPOINTMENT_BOOKED_BY_OTHERS",
  VIDEO_CALL_INVITATION = "VIDEO_CALL_INVITATION",
  VIDEO_CONSULTATION_REMINDER = "VIDEO_CONSULTATION_REMINDER",
  IN_CLINIC_APPOINTMENT_REMINDER = "IN_CLINIC_APPOINTMENT_REMINDER",
  APPOINTMENT_CANCELED = "APPOINTMENT_CANCELED",
  PATIENT_ADMITTED = "PATIENT_ADMITTED",
  PATIENT_DISCHARGED = "PATIENT_DISCHARGED",
  CLINIC_LINKED_TO_DOCTOR = "CLINIC_LINKED_TO_DOCTOR",
  DIAGNOSTIC_LINKED_TO_DOCTOR = "DIAGNOSTIC_LINKED_TO_DOCTOR",
  HOSPITAL_LINKED_TO_DOCTOR = "HOSPITAL_LINKED_TO_DOCTOR",
  MEDICINE_HOME_DELIVERY_ORDER_COMPLETED = "MEDICINE_HOME_DELIVERY_ORDER_COMPLETED",
  MEDICINE_HOME_DELIVERY_ORDER_REJECTED = "MEDICINE_HOME_DELIVERY_ORDER_REJECTED",
  MEDICINE_HOME_DELIVERY_ORDER_ACCEPTED = "MEDICINE_HOME_DELIVERY_ORDER_ACCEPTED",
  MEDICINE_PICKUP_ORDER_ACCEPTED = "MEDICINE_PICKUP_ORDER_ACCEPTED",
  MEDICINE_PICKUP_ORDER_REJECTED = "MEDICINE_PICKUP_ORDER_REJECTED",
  MEDICINE_PICKUP_ORDER_COMPLETED = "MEDICINE_PICKUP_ORDER_COMPLETED",
  NEW_DOCTOR_PRESCRIPTION_TEMPLATE = "NEW_DOCTOR_PRESCRIPTION_TEMPLATE",
  CONSULTATION_END_REMINDER = "CONSULTATION_END_REMINDER",
  CONSULTATION_END_AND_PRESCRIPTION_SHARED = "CONSULTATION_END_AND_PRESCRIPTION_SHARED",
  PATIENT_REVIEW_SUBMITTED = "PATIENT_REVIEW_SUBMITTED",
  NEW_STAFF_LINKED = "NEW_STAFF_LINKED",
  TEST_ORDER_COMPLETED = "TEST_ORDER_COMPLETED",
  TEST_ORDER_REJECTED = "TEST_ORDER_REJECTED",
  TEST_REPORT_UPLOADED = "TEST_REPORT_UPLOADED",
  SIGNUP = "SIGNUP",
  SCHEDULE_AVAILABILITY_NOT_UPDATED = "SCHEDULE_AVAILABILITY_NOT_UPDATED",
  NEW_PATIENT_APPOINTMENT_CHAT = "NEW_PATIENT_APPOINTMENT_CHAT",
  NEW_ADMITTED_PATIENT_CHAT = "NEW_ADMITTED_PATIENT_CHAT",
  PENDING_DIAGNOSTIC_ORDER_REQUEST = "PENDING_DIAGNOSTIC_ORDER_REQUEST",
  PENDING_MEDICINE_ORDER_REQUEST = "PENDING_MEDICINE_ORDER_REQUEST",
  PATIENT_HOME = "PATIENT_HOME",
  PATIENT_FIND_DOCTOR = "PATIENT_FIND_DOCTOR",
  PATIENT_MEDICINE = "PATIENT_MEDICINE",
  PATIENT_TESTS = "PATIENT_TESTS",
  PATIENT_HEALTH_HUB = "PATIENT_HEALTH_HUB",
  PATIENT_CHAT = "PATIENT_CHAT",
  PATIENT_MEDICAL_RECORDS = "PATIENT_MEDICAL_RECORDS",
  PATIENT_ASSESSMENT = "PATIENT_ASSESSMENT",
  DOCTOR_AVAILABILITY_SETTING = "DOCTOR_AVAILABILITY_SETTING",
  DOCTOR_CHAT = "DOCTOR_CHAT",
  DOCTOR_PROFILE = "DOCTOR_PROFILE",
  DOCTOR_SCHEDULE = "DOCTOR_SCHEDULE",
  DOCTOR_IP_DASH = "DOCTOR_IP_DASH",
  PHARMACY_PROFILE = "PHARMACY_PROFILE",
  DIAGNOSTIC_PROFILE = "DIAGNOSTIC_PROFILE",
  CLINIC_PROFILE = "CLINIC_PROFILE",
  TEST_ORDER_ACCEPTED = "TEST_ORDER_ACCEPTED",
  APPOINTMENT_BOOKED_VIDEO_CONSULTATION = "APPOINTMENT_BOOKED_VIDEO_CONSULTATION",
  APPOINTMENT_BOOKED_IN_CLINIC = "APPOINTMENT_BOOKED_IN_CLINIC",
  PATIENT_ADMITTED_BY_OTHERS = "PATIENT_ADMITTED_BY_OTHERS",
}

export interface IDynamicData {
  title: string;
  language: string;
  description: string;
  cta_text?: string;
  cover_image?: string;
}

export enum INotificationStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}

export interface INotificationDaum {
  id: string;
  user_id: string;
  event_type: INotificationEvents;
  notification_source: string;
  dynamic_data: IDynamicData;
  role: string;
  language: string;
  title: string;
  description: string;
  status: INotificationStatus;
  created_at: string;
  updated_at: string;
}

export interface IInAppNotificationResult {
  count: number;
  isAllNotificationRead: boolean;
  notificationData: INotificationDaum[];
}

export interface IInAppNotificationInfo {
  result: IInAppNotificationResult;
}

export type IInAppNotificationResponse = IStatusCodeMessage &
  IInAppNotificationInfo;

export interface IParams {
  page: number;
}

export interface IFirebaseStatusResult {
  result: string;
}

export type IFirebaseStatusResponse = IStatusCodeMessage &
  IFirebaseStatusResult;

export interface INotificationStatusPayload {
  notificationIds: string[];
}
